const ConnectingDirection = {
  NORTH: "北",
  NORTH_EAST: "北東",
  EAST: "東",
  SOUTH_EAST: "南東",
  SOUTH: "南",
  SOUTH_WEST: "南西",
  WEST: "西",
  NORTH_WEST: "北西",
  UNKNOWN: "わからない",
} as const;

export type IConnectingDirection = typeof ConnectingDirection[keyof typeof ConnectingDirection];

export const connectingDirectionOptions = Object.values(ConnectingDirection).map(value => ({ label: value, value }));

export default ConnectingDirection;
